import { Variant } from '~/src/hooks/useTrackLdExposure/type'

const getStorageKey = ({
  userId,
  experimentName,
  variant,
  isExperimentEnabled,
}: {
  userId?: number
  experimentName: string
  variant: Variant
  isExperimentEnabled?: boolean
}) => {
  const userPart = userId ?? 'anonymous'

  return `mixpanel_exposure:${userPart}:${experimentName}:${String(
    variant
  )}:${isExperimentEnabled}`
}

export { getStorageKey }
